// clicked-disable attribute directive
// disabloi elementin johon attribuutti lisätty click eventin jälkeen
//
// hyödyllinen estämään useampi submit napin painallus, esim. sillä
// aikaa kun käyttäjä odottaa prosessointia. useampi painallus voi johtaa
// toiminnon suorittamiseen useamman kerran.
//
// käyttö
//  <input ... clicked-disable>..</input>
//
ClickedDisableDirective.$inject = ['$timeout', 'mjQ'];
export default function ClickedDisableDirective($timeout, mjQ) {
    return {
        restrict: 'A',
        link: function (scope, ele, attrs) {
            mjQ(ele).click(function () {
                $timeout(function () {
                    attrs.$set('disabled', true);
                }, 0);
            });
        }
    };
}
